import * as React from 'react';
import {Svg, Circle} from 'react-native-svg';

const RadioUncheckedIcon = props => {
  return (
    <Svg
      width={18}
      height={19}
      viewBox="0 0 18 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Circle
        cx={9}
        cy={9.5}
        r={8.25}
        fill="#fff"
        stroke="#8697AB"
        strokeWidth={1.5}
      />
    </Svg>
  );
};

export default RadioUncheckedIcon;
